import JobDetailsContainer from "../../../components/miscellaneous/jobSearch/jobDetails";

const JobDetails = () => {
  return <JobDetailsContainer />;
};

export default JobDetails;
